export default function Apps() {
  return (
    <p>
      The Applications to which the Customer shall have access are detailed in the contract summary that will be provided to the Customer upon confirmation of the order.
      <br /><br />
      The Customer is free during the Term of this Contract for Services to add to the selection of Applications, subject to availability of required Applications from the Information Service Provider.  The Fees shall be amended accordingly in the event of such modification and charged to the Customer on a pro-rata basis up to the date of the next renewal.
    </p>
  );
}
